import React, { useState } from 'react'
import { Color } from '../../utils/constants'
import PageHeader from '../../partials/PageHeader'
import Background from '../../assets/backgrounds/technology.svg'
import BackgroundMobile from '../../assets/backgrounds/technology-mobile.svg'
import LinkCards from '../../partials/LinkCards/LinkCards'
import HowItWorks from './components/HowItWorks/HowItWorks'
import Segments from './components/Segments'
import InformationBlock from '../../partials/InformationBlock'
import PaddingContext, { PaddingProps } from '../../utils/PaddingContext'

const Technology = () => {
    const [padding, setPadding] = useState<PaddingProps>()
    return (
        <PaddingContext.Provider value={{ padding }}>
            <PageHeader
                title='page.technology.title'
                description='page.technology.description'
                bgColor={Color.GREEN_LIGHT}
                component={Background}
                mobileComponent={BackgroundMobile}
                link={'/'}
            />
            <div className='bg-white'>
                <HowItWorks setPadding={setPadding} />
                <Segments />
                <InformationBlock
                    title='page.technology.explore'
                    description='page.technology.explore.description'
                    link='/applications'
                />
                <LinkCards
                    title1='section.linkCard.contactUs'
                    link1='/contact'
                    title2='page.careers.become'
                    link2='https://careers.biomatter.ai/'
                    external2={true}
                />
            </div>
        </PaddingContext.Provider>
    )
}

export default Technology
